import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import styled from "styled-components";

import { AppContext } from "../../contexts/AppContext";

export const ErrorField = styled.span`
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const Lessons = () => {
  const { supportingContentID } = useParams();
  const {
    setLessonsSupportingContentID,
    lessonOutlines,
    supportingContent,
  } = useContext(AppContext);
  const [body, setBody] = useState([]);
  const [head, setHead] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (supportingContentID) {
      setLessonsSupportingContentID(supportingContentID);
    }
    // eslint-disable-next-line
  }, [supportingContentID]);

  useEffect(() => {
    //dispatch(clearSupportingContent());
    if (lessonOutlines) {
      console.log("!!! LESSON OUTLINES: ", lessonOutlines);
      const keys = ["", "title", "objective", "public_id", "updated at"];
      setHead(keys);
      setBody(
        lessonOutlines.map((outline) => {
          const values = [
            outline.sequence_index + 1,
            <div
              style={{ width: "200px", fontWeight: "bold", textWrap: "wrap" }}
            >
              {outline.name}
            </div>,
            <div style={{ textWrap: "balance" }}>
              <div>{outline.data}</div>
            </div>,
            outline.public_id,
            outline.updated_at,
            <></>,
          ];
          return values;
        })
      );
    }
  }, [lessonOutlines]);

  console.log("supportingContent ID: ", supportingContentID);
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("STATE: ", location);
  }, [location]);

  const editLesson = (row) => {
    const lesson = {};
    head.forEach((key, index) => {
      lesson[key] = row[index];
    });
    //NiceModal.show('add-agent', {agent: agent});
    navigate(`/lesson/${lesson.public_id}`, {
      lesson: lesson,
      lessonNumber: lesson.sequence_index + 1,
    });
  };

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="relative p-6 flex-auto ">
              <div>
                <a href={`/supportingcontent/${supportingContentID}`}>
                  <i className="fa fa-arrow-left" /> Back to{" "}
                  {supportingContent
                    ? supportingContent.name
                    : "Loading Supporting Content"}
                </a>{" "}
              </div>
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <div className="flex flex-wrap">
                  <div className="w-full px-4">
                    <CardFullTable
                      title="Lessons"
                      titlebutton={
                        <i
                          onClick={() => navigate("/lesson/")}
                          className="fa fa-plus text-sm cursor-pointer"
                        />
                      }
                      head={head}
                      body={body}
                      color="white"
                      onRowClick={(row) => editLesson(row)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Lessons;
